module.exports = __webpack_public_path__ + "static/media/featured-post.8381d78d.svg";